const hasCompanyType = values =>
  Boolean(values.find(({ type }) => type === 'company'));

export default hasCompanyType;
